module.exports = __webpack_public_path__ + "img/tramites.ed8bfae7.png";